/* src/app/components/LogOutButton/styles.js */

export default theme => ({
  icon: {
    marginRight: theme.spacing.unit,
  },
  logOutButton: {
    margin: theme.spacing.unit,
  },
});



// WEBPACK FOOTER //
// ./src/app/components/LogOutButton/styles.js